export enum TransactionFilterType {
    Online = "Online",
    All = "All",
    InStore = "In Store" 
}


// WEBPACK FOOTER //
// ./src/model/types/transaction-filter-type.ts